import React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import style from './image.mod.scss'
import { isBrowser } from '@context/themeContext'

const mql = isBrowser() ? window.matchMedia('(min-width: 1024px)') : false

const Image = ({
  image,
  mobileImage,
  elevated = false,
  modifiers = [],
  aspectRatio = null,
  moduleStyle
}) => {
  elevated && modifiers.push(style['image--elevated'])
  moduleStyle &&
    modifiers.push(
      style[
        `image--${moduleStyle
          .trim()
          .toLowerCase()
          .replace(/ /gi, '-')}`
      ]
    )

  const interpretAspectRatio = () => {
    switch (aspectRatio) {
      case 'Wide Landscape':
        return '2.6:1'
      case 'Landscape':
        return '16:9'
      case 'Small Landscape':
        return '5:4'
      case 'Square':
        return '1:1'
      case 'Portrait':
        return '4:5'
      default:
        return '16:9'
    }
  }

  const getFluid = () => {
    const imageSources = [
      {
        ...image.fluid
      }
    ]

    if (mql && aspectRatio) {
      const interpretedAspectRatio = interpretAspectRatio()

      imageSources.splice(0, 1, {
        ...image.fluid,
        aspectRatio: eval(interpretedAspectRatio.replace(/:/g, '/')),
        src: image.fluid.src.replace(
          /ar=16%3A9/g,
          `ar=${interpretedAspectRatio}`
        ),
        srcSet: image.fluid.srcSet.replace(
          /ar=16%3A9/g,
          `ar=${interpretedAspectRatio}`
        )
      })
    }

    if (mobileImage) {
      imageSources.unshift({
        ...mobileImage.fluid,
        media: `(max-width: 1024px)`
      })
    }

    return imageSources
  }

  return (
    <div className={[style.image, ...modifiers].join(' ')}>
      {image && (
        <div className={style.image__wrap}>
          <Img fluid={[...getFluid()]} />
        </div>
      )}
    </div>
  )
}

export default Image

export const query = graphql`
  fragment Image on DatoCmsImage {
    heading
    image {
      fluid(maxWidth: 970, imgixParams: { fit: "crop", w: "970", h: "545" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    padding
    moduleStyle
    id
    background
    backgroundStyle
    model {
      apiKey
    }
    link {
      ...Link
    }
  }

  fragment ImageWithArtDirection on DatoCmsImageWithArtDirection {
    heading
    image {
      fluid(
        maxWidth: 1940
        imgixParams: { fit: "crop", w: "1940", h: "1090" }
      ) {
        ...GatsbyDatoCmsFluid
      }
    }
    mobileImage {
      fluid(imgixParams: { fit: "crop", h: "478" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    aspectRatio
    padding
    moduleStyle
    id
    background
    model {
      apiKey
    }
    link {
      ...Link
    }
  }

  fragment ImageWithContent on DatoCmsImageWithContent {
    id
    background
    backgroundStyle
    padding
    moduleStyle
    model {
      apiKey
    }
    heading
    contentNode {
      childMarkdownRemark {
        html
      }
    }
    image {
      fluid(maxWidth: 600, imgixParams: { fit: "crop", w: "600", h: "490" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    link {
      ...Link
    }
  }
`
